import * as XLSX from 'xlsx';
import React from 'react';

const TenantImporter: React.FC = () => {
  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      try {
        const result = e.target?.result;
        if (!result) return;
        const data = new Uint8Array(result as ArrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData: any[][] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        const tenantData = [];
        for (let i = 1; i < jsonData.length; i++) {
          const row = jsonData[i];
          if (!row || row.length === 0) continue;

          const tenantRecord = {
            property: row[0] || '',
            unit: row[1] || '',
            tenant: row[2] || '',
            tenantType: row[4] || '',
            phoneNumbers: row[5] || '',
            emails: row[6] || '',
          };

          // Skip header rows (check if tenant field contains header-like text)
          const isHeaderRow = tenantRecord.tenant === 'Tenant' || 
                             tenantRecord.property === 'Property' ||
                             tenantRecord.unit === 'Unit';

          if (tenantRecord.tenant && 
              tenantRecord.tenant.trim() !== '' && 
              !isHeaderRow) {
            tenantData.push(tenantRecord);
          }
        }

        console.log('Extracted Tenant Data:', tenantData);

      } catch (error) {
        console.error('Error processing file:', error);
      }
    };

    reader.readAsArrayBuffer(file);
    event.target.value = '';
  };

  const triggerFileUpload = () => {
    const input = document.getElementById('tenant-file-input') as HTMLInputElement | null;
    if (input) input.click();
  };

  return (
    <>
      <input
        id="tenant-file-input"
        type="file"
        accept=".xlsx,.xls"
        onChange={handleFileUpload}
        className="hidden"
      />
         <button
        onClick={triggerFileUpload}
        className="inline-flex items-center gap-2 py-2 px-4 text-sm font-medium rounded-lg bg-blue-50 text-blue-700 hover:bg-blue-100 active:scale-[0.98] transition-all duration-200"
        type="button"
      >
        Import Tenants
      </button>
    </>
  );
};

export default TenantImporter;